import React from "react";
import styled from '@emotion/styled';
import { Delete } from "@mui/icons-material";
import { cardBrandInfo, cardBrandLabel } from "./cardBrand";

const SavedPaymentMethod = ({ pm, selectedPaymentMethod, onSelect, onDelete }) => {
  const brand = cardBrandInfo(pm.card?.brand);
  const brandLabel = cardBrandLabel(pm.card?.brand);

  return (
  <Container selected={selectedPaymentMethod === pm.id} onClick={() => onSelect(pm.id)}>
    <Radio selected={selectedPaymentMethod === pm.id}>
      {selectedPaymentMethod === pm.id && <RadioInner />}
    </Radio>

    {/* Logo when we hold the artwork; the brand name still appears below, so a
        network we have no asset for (JCB, Diners) degrades to text rather than
        a broken image. */}
    {brand && (
      <BrandLogo plate={brand.needsPlate}>
        <img src={brand.src} alt={brandLabel} />
      </BrandLogo>
    )}

    <CardInfo>
      <CardLast4>•••• •••• •••• {pm.card?.last4}</CardLast4>
      <CardDetails>
        {brandLabel}
        {/*
          Authorize.Net returns the expiry masked as "XXXX" on stored payment
          profiles unless the account is permitted to unmask it, so exp_month /
          exp_year can legitimately be null. Rendering them unconditionally
          produced a bare "expires /". Stripe and Square return real values, so
          they are unaffected.
        */}
        {pm.card?.exp_month && pm.card?.exp_year
          ? ` · expires ${pm.card.exp_month}/${pm.card.exp_year}`
          : ""}
      </CardDetails>
    </CardInfo>
    {onDelete && (
      <DeleteButton
        onClick={(e) => {
          e.stopPropagation();
          onDelete(pm.id);
        }}
        title="Delete payment method"
      >
        <Delete style={{ fontSize: 16 }} />
      </DeleteButton>
    )}
  </Container>
  );
};

const Container = styled.div`
  border: ${({ selected }) => (selected ? '2px solid #3B72FE' : '1px solid #ddd')};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: border 0.2s;
  &:hover {
    border: 2px solid #3B72FE;
  }
`;

const Radio = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: ${({ selected }) => (selected ? '2px solid #3B72FE' : '2px solid #ccc')};
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RadioInner = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #3B72FE;
`;

const BrandLogo = styled.div`
  width: 42px;
  height: 28px;
  margin-right: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  /* The Visa artwork is dark with a transparent background and needs a plate to
     stay legible; the others carry their own. */
  background: ${({ plate }) => (plate ? "#fff" : "transparent")};
  border: ${({ plate }) => (plate ? "1px solid #eee" : "none")};

  img {
    max-width: 100%;
    max-height: 100%;
    /* contain, so a wordmark and a roundel both sit correctly in one box */
    object-fit: contain;
    display: block;
  }
`;

const CardInfo = styled.div`
  flex: 1;
`;

const CardLast4 = styled.div`
  font-weight: bold;
`;

const CardDetails = styled.div`
  font-size: 14px;
  color: #666;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background-color: #f5f5f5;
    color: #d32f2f;
  }

  &:focus {
    outline: 2px solid #3B72FE;
    outline-offset: 2px;
  }
`;


export default SavedPaymentMethod;
